import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/assets/icons/starIcon.svg'


const _hoisted_1 = {
  class: "contact-form",
  id: "contact"
}
const _hoisted_2 = { class: "section-title limit-width" }
const _hoisted_3 = { class: "contact-form-box-section limit-width" }
const _hoisted_4 = { class: "contact-form-box-row" }
const _hoisted_5 = { class: "contact-form-box-row" }
const _hoisted_6 = { class: "contact-form-box-section limit-width" }
const _hoisted_7 = {
  key: 0,
  class: "small-list-text-uppercase error-text"
}
const _hoisted_8 = { class: "contact-form-box-section-options" }
const _hoisted_9 = ["value", "id"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "contact-form-box-section limit-width" }
const _hoisted_12 = {
  key: 0,
  class: "small-list-text-uppercase error-text"
}
const _hoisted_13 = {
  key: 0,
  class: "contact-form-box-section-options"
}
const _hoisted_14 = ["value", "id"]
const _hoisted_15 = ["for"]
const _hoisted_16 = {
  key: 0,
  class: "contact-form-box-section-options-info"
}
const _hoisted_17 = {
  key: 1,
  class: "contact-form-box-error-text-box error-text"
}
const _hoisted_18 = {
  key: 1,
  class: "contact-form-box-error-text-box"
}
const _hoisted_19 = {
  key: 0,
  class: "small-list-text-uppercase error-text"
}
const _hoisted_20 = {
  key: 0,
  class: "contact-form-box-section-options"
}
const _hoisted_21 = ["value", "id"]
const _hoisted_22 = ["for"]
const _hoisted_23 = {
  key: 0,
  class: "contact-form-box-section-options-info"
}
const _hoisted_24 = { class: "doctor-items" }
const _hoisted_25 = ["value", "id"]
const _hoisted_26 = ["for"]
const _hoisted_27 = {
  key: 0,
  class: "doctor-items-info"
}
const _hoisted_28 = {
  key: 1,
  class: "contact-form-box-error-text-box error-text"
}
const _hoisted_29 = {
  key: 1,
  class: "contact-form-box-error-text-box"
}
const _hoisted_30 = {
  key: 1,
  class: "contact-form-box-section contact-form-box-section-times"
}
const _hoisted_31 = {
  key: 0,
  class: "small-list-text-uppercase error-text"
}
const _hoisted_32 = { class: "date-items" }
const _hoisted_33 = ["value", "id"]
const _hoisted_34 = ["for"]
const _hoisted_35 = { class: "date-items-day" }
const _hoisted_36 = {
  key: 1,
  class: "contact-form-box-error-text-box error-text"
}
const _hoisted_37 = {
  key: 1,
  class: "contact-form-box-error-text-box"
}
const _hoisted_38 = {
  key: 2,
  class: "contact-form-box-section contact-form-box-section-times"
}
const _hoisted_39 = {
  key: 0,
  class: "small-list-text-uppercase error-text"
}
const _hoisted_40 = { class: "contact-form-box-section-times-box-time" }
const _hoisted_41 = ["value", "disabled", "checked", "onClick", "id"]
const _hoisted_42 = ["for"]
const _hoisted_43 = {
  key: 1,
  class: "contact-form-box-error-text-box error-text"
}
const _hoisted_44 = {
  key: 1,
  class: "contact-form-box-error-text-box"
}
const _hoisted_45 = { class: "contact-form-box-section limit-width" }
const _hoisted_46 = {
  key: 0,
  class: "small-list-text-uppercase error-text"
}
const _hoisted_47 = { class: "contact-form-box-row" }
const _hoisted_48 = { class: "checkbox-column" }
const _hoisted_49 = { class: "checkbox" }
const _hoisted_50 = { for: "any_day" }
const _hoisted_51 = { for: "terms" }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = {
  class: "button",
  type: "submit"
}
const _hoisted_54 = {
  key: 0,
  class: "modal-background"
}
const _hoisted_55 = { class: "modal-content" }
const _hoisted_56 = { class: "modal-content-header" }
const _hoisted_57 = { class: "list-text-bold" }
const _hoisted_58 = { class: "modal-slot-booked-row" }
const _hoisted_59 = { class: "modal-slot-booked-column" }
const _hoisted_60 = { class: "list-text-bold" }
const _hoisted_61 = {
  key: 0,
  class: "small-list-text"
}
const _hoisted_62 = { class: "modal-slot-booked-column" }
const _hoisted_63 = { class: "list-text-bold" }
const _hoisted_64 = { class: "list-text" }
const _hoisted_65 = {
  key: 1,
  class: "modal-background"
}
const _hoisted_66 = { class: "modal-content" }
const _hoisted_67 = { class: "modal-content-header" }
const _hoisted_68 = { class: "list-text-bold" }
const _hoisted_69 = ["innerHTML"]

import { nextTick, reactive, ref, watch } from 'vue';
import InputComponent from '@/components/form-components/InputComponent.vue';
import TextareaComponent from '@/components/form-components/TextareaComponent.vue';
import SwiperComponent from '@/components/SwiperComponent.vue';
import axios from 'axios';
import QDateTime from '@/QDateTime';
import { generalStore } from '@/store';
import router from '@/router';
import handleValidation from '@/composables/validationHandler';
import __ from '@/translate';
import type { ContactForm, ParsedSlot, ContactFormLocation, ContactFormDoctors } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactForm',
  setup(__props) {

const openedTerms = ref(false);

const daysMap = {
  Mon: 'monday',
  Tue: 'tuesday',
  Wed: 'wednesday',
  Thu: 'thursday',
  Fri: 'friday',
  Sat: 'saturday',
  Sun: 'sunday',
};

const contactForm = ref<ContactForm>({
  name: '',
  surname: '',
  email: '',
  phone: '',
  visitType: '',
  startAt: '',
  startAtTime: null,
  comment: '',
  newsletter: false,
  terms: false,
  locationId: null,
  doctorId: null,
});
const validation = reactive(handleValidation<ContactForm>(contactForm));
const address = ref<string>('');
const doctorId = ref<number | null>(null);
const visitType = ['visit_type_first_visit', 'visit_type_tartar_removal', 'visit_type_pain', 'visit_type_other'];
const slotReservationBooked = ref(false);
const submitted = ref(false);
const slots = ref<Record<string, ParsedSlot[]>>({});
const fetchingSlots = ref(false);
const fetchingDoctors = ref(false);
const fetchingLocations = ref(false);
const locations = ref<ContactFormLocation[]>([]);
const doctors = ref<ContactFormDoctors[]>([]);

const store = generalStore();

watch(() => contactForm.value.visitType, fetchLocations);
watch(() => [address.value, contactForm.value.visitType], fetchDoctors);
watch(() => [address.value, contactForm.value.visitType, doctorId.value], fetchSlots);

watch(
  () => contactForm.value.startAt,
  (newDate) => {
    console.log('New date selected:', newDate, contactForm.value.startAtTime);
    contactForm.value.startAtTime = null;
    contactForm.value.locationId = null;
    contactForm.value.doctorId = null;
  },
  {
    deep: true,
  }
);

const slotClient = axios.create({
  transformResponse: (data) => {
    return JSON.parse(data, (key, value) => {
      return key === 'start' || key === 'end' ? QDateTime.parse(value).setZone('Europe/Ljubljana') : value;
    });
  },
});

function fetchLocations() {
  contactForm.value.startAt = null;
  contactForm.value.startAtTime = null;
  address.value = '';
  doctorId.value = null;
  if (!contactForm.value.visitType) {
    locations.value = [];
    return;
  }

  fetchingLocations.value = true;
  axios
    .get('/api/addresses', {
      params: {
        visitType: contactForm.value.visitType,
      },
    })
    .then((response) => {
      locations.value = response.data;
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      fetchingLocations.value = false;
    });
}

function fetchDoctors() {
  doctorId.value = null;
  contactForm.value.startAt = null;
  contactForm.value.startAtTime = null;
  if (!address.value || !contactForm.value.visitType) {
    doctors.value = [];
    return;
  }
  fetchingDoctors.value = true;
  axios
    .get('/api/doctors', {
      params: {
        address: address.value,
        visitType: contactForm.value.visitType,
      },
    })
    .then((response) => {
      doctors.value = response.data;
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      fetchingDoctors.value = false;
    });
}

function fetchSlots() {
  contactForm.value.startAt = null;
  contactForm.value.startAtTime = null;
  contactForm.value.locationId = null;
  contactForm.value.doctorId = null;
  slots.value = {};
  if (!contactForm.value.visitType || !address.value || !doctorId.value) {
    return;
  }
  fetchingSlots.value = true;
  slotClient
    .post<Record<string, ParsedSlot[]>>('/api/slots', {
      visitType: contactForm.value.visitType,
      doctorId: doctorId.value,
      address: address.value,
    })
    .then((response) => {
      console.log(response.data);
      slots.value = response.data;
      if (
        contactForm.value.startAt &&
        !(slots.value[contactForm.value.startAt] && slots.value[contactForm.value.startAt].length)
      ) {
        contactForm.value.startAt = null;
        contactForm.value.startAtTime = null;
      }
    })
    .catch((reason) => {
      console.log(reason);
    })
    .finally(() => {
      fetchingSlots.value = false;
    });
}
function submitForm(): void {
  if (submitted.value) {
    return;
  }
  // if (!contactForm.value.startAtTime) {
  //   return;
  // }
  const startTime = contactForm.value.startAtTime;
  submitted.value = true;
  axios
    .post('/api/reservations', {
      name: contactForm.value.name,
      surname: contactForm.value.surname,
      email: contactForm.value.email,
      phone: contactForm.value.phone,
      comment: contactForm.value.comment,
      startAt: startTime ? startTime.toString() : null,
      visitType: contactForm.value.visitType,
      newsletter: contactForm.value.newsletter,
      terms: contactForm.value.terms,
      doctorId: contactForm.value.doctorId,
      locationId: contactForm.value.locationId,
    })
    .then(() => {
      validation.clearErrors();
      store.submittedData = {
        time: startTime!,
        visitType: contactForm.value.visitType,
        comment: contactForm.value.comment,
        location: locations.value.find((l) => l.address === address.value)?.address || '',
        doctor: doctors.value.find((d) => d.id === contactForm.value.doctorId)?.name || '',
      };
      contactForm.value = {
        name: '',
        surname: '',
        email: '',
        phone: '',
        visitType: '',
        startAt: null,
        startAtTime: null,
        comment: '',
        newsletter: false,
        terms: false,
        doctorId: null,
        locationId: null,
      };
      submitted.value = false;
      router.push({ name: 'SuccessPage' });
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.includes('not available')
      ) {
        slotReservationBooked.value = true;
      }
      validation.setErrors(error.response.data.errors);
      nextTick(() => {
        const firstInvalid = document.querySelector<HTMLElement>('.is-invalid');

        if (firstInvalid) {
          window.scrollTo({
            top: firstInvalid.offsetTop - 120,
            behavior: 'smooth',
          });
        }
      });
      submitted.value = false;
    });
}

function handleAlreadyBookedReservation() {
  slotReservationBooked.value = false;
  contactForm.value.startAtTime = null;
  fetchSlots();
}

function selectTimeSlot(item: ParsedSlot) {
  if (item.available === false) {
    return;
  }

  contactForm.value.startAtTime = item.start;
  contactForm.value.locationId = item.locationId;
  contactForm.value.doctorId = item.doctorId;
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(__)('reserve_appointment')), 1),
      _createElementVNode("form", {
        class: "contact-form-box",
        onSubmit: _withModifiers(submitForm, ["prevent"]),
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", {
            class: _normalizeClass(["list-text-bold", {
            'error-text':
              validation.validate.includes('name') ||
              validation.validate.includes('surname') ||
              validation.validate.includes('email') ||
              validation.validate.includes('phone'),
          }])
          }, _toDisplayString(_unref(__)('your_information')), 3),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(InputComponent, {
              autocomplete: "given-name",
              placeholder: _unref(__)('form_name'),
              modelValue: contactForm.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactForm.value.name) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (validation.removeError('name'))),
              "error-message": validation.getError('name'),
              class: _normalizeClass({
              'is-invalid': validation.validate.includes('name'),
            })
            }, null, 8, ["placeholder", "modelValue", "error-message", "class"]),
            _createVNode(InputComponent, {
              autocomplete: "family-name",
              placeholder: _unref(__)('form_surname'),
              modelValue: contactForm.value.surname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contactForm.value.surname) = $event)),
              onInput: _cache[3] || (_cache[3] = ($event: any) => (validation.removeError('surname'))),
              "error-message": validation.getError('surname'),
              class: _normalizeClass({
              'is-invalid': validation.validate.includes('surname'),
            })
            }, null, 8, ["placeholder", "modelValue", "error-message", "class"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(InputComponent, {
              autocomplete: "email",
              "input-type": "email",
              inputmode: "email",
              placeholder: _unref(__)('form_email'),
              modelValue: contactForm.value.email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((contactForm.value.email) = $event)),
              onInput: _cache[5] || (_cache[5] = ($event: any) => (validation.removeError('email'))),
              "error-message": validation.getError('email'),
              class: _normalizeClass({
              'is-invalid': validation.validate.includes('email'),
            })
            }, null, 8, ["placeholder", "modelValue", "error-message", "class"]),
            _createVNode(InputComponent, {
              "input-type": 'tel',
              inputmode: "tel",
              autocomplete: "tel",
              placeholder: _unref(__)('form_phone'),
              modelValue: contactForm.value.phone,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((contactForm.value.phone) = $event)),
              onInput: _cache[7] || (_cache[7] = ($event: any) => (validation.removeError('phone'))),
              "error-message": validation.getError('phone'),
              class: _normalizeClass({
              'is-invalid': validation.validate.includes('phone'),
            })
            }, null, 8, ["placeholder", "modelValue", "error-message", "class"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", {
            class: _normalizeClass(["list-text-bold", {
            'error-text': validation.validate.includes('visitType'),
          }])
          }, [
            _createTextVNode(_toDisplayString(_unref(__)('form_visit_reason')) + " ", 1),
            (validation.getError('visitType'))
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(validation.getError('visitType')), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(visitType, (option) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: option }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  value: option,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((contactForm.value.visitType) = $event)),
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (validation.removeError('visitType'))),
                  name: "visitType",
                  id: 'visitType' + option
                }, null, 40, _hoisted_9), [
                  [_vModelRadio, contactForm.value.visitType]
                ]),
                _createElementVNode("label", {
                  for: 'visitType' + option
                }, _toDisplayString(_unref(__)(option)), 9, _hoisted_10)
              ], 64))
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", {
            class: _normalizeClass(["list-text-bold", {
            'error-text': validation.getError('locationId'),
          }])
          }, [
            _createTextVNode(_toDisplayString(_unref(__)('form_locations')) + " ", 1),
            (validation.getError('locationId'))
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(validation.getError('locationId')), 1))
              : _createCommentVNode("", true)
          ], 2),
          (contactForm.value.visitType)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (locations.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locations.value, (location) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: location.address
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: location.address,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((address).value = $event)),
                            onChange: _cache[11] || (_cache[11] = ($event: any) => (validation.removeError('locationId'))),
                            name: "location",
                            id: 'location' + location.address
                          }, null, 40, _hoisted_14), [
                            [_vModelRadio, address.value]
                          ]),
                          _createElementVNode("label", {
                            for: 'location' + location.address
                          }, [
                            _createTextVNode(_toDisplayString(location.address) + " ", 1),
                            (location.firstSlot)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(__)('contact_form_available_from')) + " " + _toDisplayString(_unref(QDateTime).parse(location.firstSlot).format('dd.MM.yyyy')), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_15)
                        ], 64))
                      }), 128))
                    ]))
                  : (!fetchingLocations.value && !locations.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(__)('contact_form_no_locations')), 1))
                    : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(__)('select_reason_to_show_locations')), 1))
        ]),
        (contactForm.value.visitType)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["contact-form-box-section", {
          'limit-width ': !_unref(store).isMobile && !_unref(store).isTablet,
          'contact-form-box-section-times': _unref(store).isMobile || _unref(store).isTablet,
        }])
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(["list-text-bold", {
            'error-text': validation.getError('doctorId'),
            'limit-width': _unref(store).isMobile || _unref(store).isTablet,
          }])
              }, [
                _createTextVNode(_toDisplayString(_unref(__)('form_doctor')) + " ", 1),
                (validation.getError('doctorId'))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(validation.getError('doctorId')), 1))
                  : _createCommentVNode("", true)
              ], 2),
              (address.value && contactForm.value.visitType)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (doctors.value.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!_unref(store).isMobile && !_unref(store).isTablet)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doctors.value, (doctor) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: doctor.id
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "radio",
                                      value: doctor.id,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((doctorId).value = $event)),
                                      onChange: _cache[13] || (_cache[13] = ($event: any) => (validation.removeError('doctorId'))),
                                      name: "doctor",
                                      id: 'doctor' + doctor.id
                                    }, null, 40, _hoisted_21), [
                                      [_vModelRadio, doctorId.value]
                                    ]),
                                    _createElementVNode("label", {
                                      for: 'doctor' + doctor.id
                                    }, [
                                      _createTextVNode(_toDisplayString(doctor.name) + " ", 1),
                                      (doctor.firstSlot)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_unref(__)('contact_form_available_from')) + " " + _toDisplayString(_unref(QDateTime).parse(doctor.firstSlot).format('dd.MM.yyyy')), 1))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_22)
                                  ], 64))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock(SwiperComponent, {
                                key: 1,
                                items: doctors.value,
                                "children-class": ".doctor-items"
                              }, {
                                item: _withCtx(({ item: doctor }) => [
                                  _createElementVNode("div", _hoisted_24, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "radio",
                                      value: doctor.id,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((doctorId).value = $event)),
                                      onChange: _cache[15] || (_cache[15] = ($event: any) => (validation.removeError('doctorId'))),
                                      name: "doctor",
                                      id: 'doctor' + doctor.id
                                    }, null, 40, _hoisted_25), [
                                      [_vModelRadio, doctorId.value]
                                    ]),
                                    _createElementVNode("label", {
                                      for: 'doctor' + doctor.id,
                                      class: "list-text-bold"
                                    }, [
                                      _createTextVNode(_toDisplayString(doctor.name) + " ", 1),
                                      (doctor.firstSlot)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(__)('contact_form_available_from')) + " " + _toDisplayString(_unref(QDateTime).parse(doctor.firstSlot).format('dd.MM.yyyy')), 1))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_26)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["items"]))
                        ], 64))
                      : (!fetchingDoctors.value && !doctors.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(__)('contact_form_no_doctors')), 1))
                        : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(__)('select_location_to_show_doctors')), 1))
            ], 2))
          : _createCommentVNode("", true),
        (contactForm.value.visitType && address.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("p", {
                class: _normalizeClass(["list-text-bold limit-width", {
            'error-text': validation.getError('startAt') && !contactForm.value.startAt,
          }])
              }, [
                _createTextVNode(_toDisplayString(_unref(__)('contact_form_date')) + " ", 1),
                (validation.getError('startAt') && !contactForm.value.startAt)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(validation.getError('startAt')), 1))
                  : _createCommentVNode("", true)
              ], 2),
              (doctorId.value !== null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!fetchingSlots.value && slots.value && Object.keys(slots.value).length)
                      ? (_openBlock(), _createBlock(SwiperComponent, {
                          key: 0,
                          items: Object.keys(slots.value),
                          "children-class": ".date-items"
                        }, {
                          item: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_32, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                value: item.toString(),
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((contactForm.value.startAt) = $event)),
                                id: 'startAt' + item.toString(),
                                onChange: _cache[17] || (_cache[17] = ($event: any) => (validation.removeError('startAt'))),
                                name: "startAt"
                              }, null, 40, _hoisted_33), [
                                [_vModelRadio, contactForm.value.startAt]
                              ]),
                              _createElementVNode("label", {
                                for: 'startAt' + item.toString(),
                                class: "list-text-bold"
                              }, [
                                _createTextVNode(_toDisplayString(_unref(QDateTime).parse(item).format('dd.MM.')) + " ", 1),
                                _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(__)(daysMap[_unref(QDateTime).parse(item).weekdayShort?.toString() as keyof typeof daysMap])), 1)
                              ], 8, _hoisted_34)
                            ])
                          ]),
                          _: 1
                        }, 8, ["items"]))
                      : (!fetchingSlots.value && (!slots.value || !Object.keys(slots.value).length))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_unref(__)('contact_form_no_dates')), 1))
                        : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(__)('select_reason_location_doctor_to_show_dates')), 1))
            ]))
          : _createCommentVNode("", true),
        (contactForm.value.visitType && address.value && doctorId.value !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("p", {
                class: _normalizeClass(["list-text-bold limit-width", {
            'error-text': validation.getError('startAt') && contactForm.value.startAt,
          }])
              }, [
                _createTextVNode(_toDisplayString(_unref(__)('contact_form_time')) + " ", 1),
                (validation.getError('startAt') && contactForm.value.startAt)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(validation.getError('startAt')), 1))
                  : _createCommentVNode("", true)
              ], 2),
              (contactForm.value.startAt)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (slots.value[contactForm.value.startAt] && slots.value[contactForm.value.startAt].length)
                      ? (_openBlock(), _createBlock(SwiperComponent, {
                          key: 0,
                          items: slots.value[contactForm.value.startAt],
                          "children-class": ".contact-form-box-section-times-box-time"
                        }, {
                          item: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("input", {
                                type: "radio",
                                value: item.start,
                                disabled: item.available === false,
                                checked: contactForm.value.startAtTime === item.start,
                                onClick: ($event: any) => (selectTimeSlot(item)),
                                id: 'startAtTime' + item.start,
                                onChange: _cache[18] || (_cache[18] = ($event: any) => (validation.removeError('startAt'))),
                                name: "startAtTime"
                              }, null, 40, _hoisted_41),
                              _createElementVNode("label", {
                                for: 'startAtTime' + item.start,
                                class: "normal-text-bold"
                              }, _toDisplayString(item.start.format('HH:mm')), 9, _hoisted_42)
                            ])
                          ]),
                          _: 1
                        }, 8, ["items"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_unref(__)('no_appointments_available')), 1))
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_unref(__)('select_date_to_show_times')), 1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("p", {
            class: _normalizeClass(["list-text-bold", {
            'error-text': validation.validate.includes('comment'),
          }])
          }, [
            _createTextVNode(_toDisplayString(_unref(__)('comment_form')) + " ", 1),
            (validation.getError('comment'))
              ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(validation.getError('comment')), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(TextareaComponent, {
              modelValue: contactForm.value.comment,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((contactForm.value.comment) = $event)),
              class: _normalizeClass({
              'is-invalid': validation.validate.includes('comment'),
            }),
              onInput: _cache[20] || (_cache[20] = ($event: any) => (validation.removeError('comment')))
            }, null, 8, ["modelValue", "class"])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "any_day",
              value: true,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((contactForm.value.newsletter) = $event))
            }, null, 512), [
              [_vModelCheckbox, contactForm.value.newsletter]
            ]),
            _createElementVNode("label", _hoisted_50, _toDisplayString(_unref(__)('newsletter_text')), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["checkbox", {
            'is-invalid': validation.validate.includes('terms'),
          }])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "terms",
              value: true,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((contactForm.value.terms) = $event)),
              onChange: _cache[23] || (_cache[23] = ($event: any) => (validation.removeError('terms')))
            }, null, 544), [
              [_vModelCheckbox, contactForm.value.terms]
            ]),
            _createElementVNode("label", _hoisted_51, [
              _createElementVNode("p", {
                class: "list-text",
                innerHTML: _unref(__)('contact_form_legal_text_checkbox')
              }, null, 8, _hoisted_52),
              (_openBlock(), _createElementBlock("svg", {
                style: {"display":"inline"},
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (openedTerms.value = true), ["prevent"])),
                height: "19",
                viewBox: "0 0 18 19",
                fill: "none"
              }, _cache[27] || (_cache[27] = [
                _createElementVNode("circle", {
                  cx: "9",
                  cy: "9.5",
                  r: "8.5",
                  stroke: "#15BBBD"
                }, null, -1),
                _createElementVNode("path", {
                  d: "M9 4.5V10.5",
                  stroke: "#15BBBD"
                }, null, -1),
                _createElementVNode("path", {
                  d: "M9 14.5V12.5",
                  stroke: "#15BBBD"
                }, null, -1)
              ])))
            ])
          ], 2)
        ]),
        _createElementVNode("button", _hoisted_53, [
          _cache[28] || (_cache[28] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(__)('submit_form')), 1)
        ])
      ], 32)
    ]),
    (slotReservationBooked.value && contactForm.value.startAt && contactForm.value.startAtTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("p", _hoisted_57, _toDisplayString(_unref(__)('slot_no_longer_available')), 1),
              _createElementVNode("div", {
                class: "modal-close",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (handleAlreadyBookedReservation()))
              }, _cache[29] || (_cache[29] = [
                _createElementVNode("div", { class: "x-icon" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("p", _hoisted_60, _toDisplayString(_unref(QDateTime).parse(contactForm.value.startAt).setZone('Europe/Ljubljana').format('dd.MM')), 1),
                (contactForm.value.startAt)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(_unref(__)(
                daysMap[
                  _unref(QDateTime).parse(contactForm.value.startAt)
                    .setZone('Europe/Ljubljana')
                    .weekdayShort?.toString() as keyof typeof daysMap
                ]
              )), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("p", _hoisted_63, _toDisplayString(contactForm.value.startAtTime), 1)
              ])
            ]),
            _createElementVNode("p", _hoisted_64, _toDisplayString(_unref(__)('select_another_slot')), 1),
            _createElementVNode("button", {
              class: "button",
              onClick: handleAlreadyBookedReservation
            }, [
              _cache[30] || (_cache[30] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_unref(__)('select_new_slot_proceed')), 1)
            ])
          ])), [
            [_directive_click_outside, handleAlreadyBookedReservation]
          ])
        ]))
      : _createCommentVNode("", true),
    (openedTerms.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("p", _hoisted_68, _toDisplayString(_unref(__)('contact_form_legal_text_title')), 1),
              _createElementVNode("div", {
                class: "modal-close",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (openedTerms.value = false))
              }, _cache[31] || (_cache[31] = [
                _createElementVNode("div", { class: "x-icon" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", {
              class: "modal-content-legal",
              innerHTML: _unref(__)('contact_form_legal_text_content')
            }, null, 8, _hoisted_69)
          ])), [
            [_directive_click_outside, 
        () => {
          openedTerms.value = false;
        }
      ]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})